import '../styles/pages/Contact.css';
import map_light from ".././images/Map_light.png";
import parking_lot from ".././images/Parking_Lot_Angled.jpeg";
import building_exterior from ".././images/Building_Exterior_2.jpeg";

function Contact() {
  
  return (
    <div className="contact">
      <div className="info">
        <div className="parking">
          <img src={building_exterior} className="parking_images" alt="Task Work Assessments building facing the street"></img>
          <img src={parking_lot} className="parking_images" alt="Tash Work Assessments from the parking lot entrance"></img>
          <p className="parking_notice">
            Parking available on site
          </p>
          {/* <p>
            Tash Work Assessments is 
          </p>
          <p>
            Contact us with questions or referrals!
          </p> */}
          {/* <p>
            Parking available on site.
          </p> */}
        </div>

        <div className="contact_info">
          <h3>
            Tash Work Assessments, LLC
          </h3>
          <p>
            Ph/txt: <a  className="link_text" href="sms:5034335123">(503) 433-5123</a>
          </p>
          <p>
            Fax: <a  className="link_text" href="fax:5033887373">(503) 388-7373</a>
          </p>
          <p>
            <a  className="link_text" href="mailto: trevor@tashworkassessments.com">trevor@tashworkassessments.com</a>
          </p>
          {/* <br></br>
          <p>
            5001 SE Brooklyn St., Ste B
          </p>
          <p>
            Portland, OR, 97206
          </p> */}
        </div>
      </div>

      <div className="location">
        <div className="map_info">
          <p>
            <a className="directions" href="https://www.google.com/maps/place/5001+SE+Brooklyn+St+B,+Portland,+OR+97206/@45.5010158,-122.6118324,17z/data=!4m6!3m5!1s0x5495a066d17c4bf5:0x6b9ddf25db0a836c!8m2!3d45.5011595!4d-122.610865!16s%2Fg%2F11qg0y14rg?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer" target="_blank">
              Directions
            </a>
          </p>

          <a href="https://www.google.com/maps/place/5001+SE+Brooklyn+St+B,+Portland,+OR+97206/@45.5010158,-122.6118324,17z/data=!4m6!3m5!1s0x5495a066d17c4bf5:0x6b9ddf25db0a836c!8m2!3d45.5011595!4d-122.610865!16s%2Fg%2F11qg0y14rg?entry=ttu&g_ep=EgoyMDI2MDIxMC4wIKXMDSoASAFQAw%3D%3D" rel="noreferrer" target="_blank">
            
            <img className="map_image" src={map_light} alt="Map"/>
          </a>
          <p>
            5001 SE Brooklyn St., Ste B
          </p>
          <p>
            Portland, OR, 97206
          </p>
        </div>
      </div>

    </div>

  );
}

export default Contact;